export const POSTHOG_KEY = 'phc_tSSGdZFX9EaHrNACfbZAAifcJcqEJCUwVMWj8Xrnrozu';
export const POSTHOG_HOST = 'https://us.i.posthog.com';
export const VERIFICATION_STORAGE_KEY = 'shuttleops_analytics_verification';

const STATIC_ROUTES = new Set([
  '/compare',
  '/compare/leaguesahead-alternative',
  '/compare/shuttlsync-alternative',
  '/compare/courtflow-alternative',
  '/compare/courtex-alternative',
  '/compare/epegboard-alternative',
  '/compare/paimo-alternative',
  '/compare/court-manager-alternative',
  '/compare/badmintonclub-cc-alternative',
  '/compare/clubmon-alternative',
  '/compare/sporteasy-alternative',
  '/your-club',
  '/sports-club-app',
  '/sports-club-management-software',
  '/guides/switch-from-playwaze',
  '/guides/switch-from-spond',
  '/',
  '/test-club',
  '/calculator',
  '/badminton-club-payment-software',
  '/compare/playwaze-alternative',
  '/compare/spond-alternative',
  '/compare/justgo-alternative',
  '/guides/badminton-pegboard',
  '/guides/club-attendance-register',
  '/guides/switch-from-justgo-to-shuttleops',
  '/compare/sportmember-alternative',
  '/faq',
  '/guides/badminton-club-management-software',
  '/guides/collect-badminton-club-payments',
  '/guides/first-club-session',
  '/pegboard',
  '/pricing',
  '/privacy',
  '/terms',
  '/tours',
]);

const normalizePathname = (pathname) => {
  if (typeof pathname !== 'string') {
    return null;
  }

  const pathOnly = pathname.split(/[?#]/, 1)[0];
  if (!pathOnly.startsWith('/')) {
    return null;
  }

  return pathOnly.length > 1 ? pathOnly.replace(/\/+$/, '') : pathOnly;
};

export const getRouteProperties = (pathname) => {
  const normalizedPathname = normalizePathname(pathname);

  if (!normalizedPathname) {
    return null;
  }

  if (STATIC_ROUTES.has(normalizedPathname)) {
    return {
      pathname: normalizedPathname,
      route_template: normalizedPathname,
    };
  }

  if (/^\/features\/(managers|players)$/.test(normalizedPathname)) {
    return {
      pathname: normalizedPathname,
      route_template: '/features/:persona',
    };
  }

  if (normalizedPathname === '/pulse/all') {
    return {
      pathname: normalizedPathname,
      route_template: '/pulse',
    };
  }

  if (/^\/pulse\/[a-z0-9-]+$/i.test(normalizedPathname)) {
    return {
      pathname: normalizedPathname,
      route_template: '/pulse/:slug',
    };
  }

  return null;
};

const removeQueryAndHash = (value) => {
  if (typeof value !== 'string') {
    return null;
  }

  if (value.startsWith('$')) {
    return value;
  }

  try {
    const parsedUrl = new URL(value, 'https://shuttleops.com');
    const path = parsedUrl.pathname || '/';

    if (value.startsWith('/')) {
      return path;
    }

    return `${parsedUrl.origin}${path}`;
  } catch {
    return null;
  }
};

export const sanitizeCaptureResult = (captureResult) => {
  if (!captureResult) {
    return null;
  }

  const properties = { ...(captureResult.properties || {}) };

  for (const [property, value] of Object.entries(properties)) {
    const propertyName = property.toLowerCase();
    if (!propertyName.includes('url') && !propertyName.includes('referrer')) {
      continue;
    }

    const sanitizedValue = removeQueryAndHash(value);
    if (sanitizedValue) {
      properties[property] = sanitizedValue;
    } else {
      delete properties[property];
    }
  }

  return {
    ...captureResult,
    properties,
  };
};

export const POSTHOG_OPTIONS = {
  api_host: POSTHOG_HOST,
  autocapture: false,
  capture_pageview: false,
  capture_pageleave: false,
  capture_dead_clicks: false,
  capture_exceptions: false,
  capture_performance: false,
  disable_scroll_properties: true,
  disable_session_recording: true,
  enable_heatmaps: false,
  disable_surveys: true,
  disable_surveys_automatic_display: true,
  disable_product_tours: true,
  disable_conversations: true,
  disable_web_experiments: true,
  disable_external_dependency_loading: true,
  advanced_disable_flags: true,
  advanced_disable_feature_flags: true,
  advanced_disable_feature_flags_on_first_load: true,
  person_profiles: 'never',
  persistence: 'memory',
  save_campaign_params: false,
  save_referrer: false,
  before_send: sanitizeCaptureResult,
};
